import { Link } from "react-router-dom";
import { Star, MapPin, Clock, Mountain } from "lucide-react";
import { resolveImg } from "@/lib/api";

const TYPE_LABEL = {
  dham: "Dham", temple: "Temple", yatra: "Yatra", hotel: "Hotel",
  dharamshala: "Dharamshala", package: "Package", state: "State", city: "City",
};

const FALLBACK = "https://images.unsplash.com/photo-1571536802807-30451e3955d8?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function EntityCard({ e, compact = false }) {
  return (
    <Link
      to={`/e/${e.slug}`}
      data-testid={`entity-card-${e.slug}`}
      className="group block rounded-xl bg-white overflow-hidden card-shadow border border-gold/10 hover:border-gold/40 transition-all hover:-translate-y-0.5"
    >
      <div className={`relative overflow-hidden ${compact ? "h-40" : "h-52"} bg-surfacealt`}>
        <img
          src={resolveImg(e.image) || FALLBACK}
          alt={e.name}
          loading="lazy"
          onError={(ev) => { ev.currentTarget.src = FALLBACK; }}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex gap-1.5">
          <span className="text-[10px] font-semibold tracking-widest uppercase bg-indigo-deep text-gold px-2 py-1 rounded-full">
            {TYPE_LABEL[e.type] || e.type}
          </span>
          {e.featured && (
            <span className="text-[10px] font-bold uppercase bg-gold text-indigo-deep px-2 py-1 rounded-full">Featured</span>
          )}
        </div>
        {e.rating && (
          <div className="absolute bottom-3 right-3 bg-white/95 rounded-full px-2 py-0.5 flex items-center gap-1 text-xs font-semibold">
            <Star className="w-3 h-3 fill-gold text-gold" /> {e.rating}
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-display text-lg font-semibold text-indigo-deep leading-snug line-clamp-1 group-hover:text-gold-dark transition-colors">{e.name}</h3>
        {(e.city || e.state) && (
          <div className="mt-1 flex items-center gap-1 text-xs text-indigo-deep/60">
            <MapPin className="w-3 h-3" /> {[e.city, e.state].filter(Boolean).join(", ")}
          </div>
        )}
        {e.short_desc && <p className="mt-2 text-sm text-indigo-deep/70 line-clamp-2">{e.short_desc}</p>}
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-2.5 text-xs text-indigo-deep/60">
            {e.duration_days && <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{e.duration_days}D</span>}
            {e.altitude_m && <span className="flex items-center gap-1"><Mountain className="w-3 h-3" />{e.altitude_m}m</span>}
          </div>
          {e.price ? (
            <div className="text-right">
              <div className="text-[10px] text-indigo-deep/50">from</div>
              <div className="font-display font-bold text-saffron">₹{Number(e.price).toLocaleString("en-IN")}</div>
            </div>
          ) : (
            <div className="text-xs font-medium text-gold-dark">Inquire ›</div>
          )}
        </div>
      </div>
    </Link>
  );
}
